import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MetaPageEnum } from '~/core/declaration/declaration';
import { AssetService } from '~/core/services/assets/asset.service';
import { MetaTagService } from '~/core/utils/global-utils/global-utils';
import { BreadcrumbserviceService } from '~/pages/breadcrumb/breadcrumbservice.service';
import { regionEnum } from '../../../core/declaration/declaration';
import { RegionalSettingsService } from '../../../core/store/regionalSettings/regionalSettings.service';
@Component({
  selector: 'volvo-who-we-are',
  templateUrl: './who-we-are.component.html',
  styleUrls: ['./who-we-are.component.scss']
})
export class WhoWeAreComponent implements OnInit {
  region: string;
  imageUrl: string;
  regionEnum = regionEnum;
  constructor(private translateService: TranslateService, private metaTagService: MetaTagService,
    private regionSettingService: RegionalSettingsService,
    private breadCrumbService: BreadcrumbserviceService,
    public assetService: AssetService) {
    this.regionSettingService.regionalSettings$.subscribe(r => {
      this.region = r.regionsSettings[0].region;

    });
  }

  ngOnInit(): void {
    console.log(this.region);
    switch (this.region) {
      case this.regionEnum.UK: this.imageUrl = "assets/pages/aboutUs/About us image.webp"; break;
      case this.regionEnum.TX: this.imageUrl = "assets/pages/aboutUs/AboutusimageTX.webp"; break;
    }
    this.metaTagService.updateTagFor(MetaPageEnum.WhatWhoWeAre);
    //this.breadCrumbService.updateBreadcrumb('About Us' , 'Who we are', HtmlRoutePages.aboutUs);
  }
}
